import ResponsiveImage from '@components/basics/ResponsiveImage'
import Section from '@components/elements/Section'
import React from 'react'
import { scroller } from 'react-scroll'
import styled from 'styled-components'

const Container = styled.div`
  @media (max-width: 768px) {
    text-align: center;
  }
`

const ContenBox = styled.div`
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-justify-content: center;
  justify-content: center;
  margin-top: -30px;
  h4 {
    font-size: 3rem;
    line-height: 1;
    margin: 0 0 20px;
  }
  p {
    margin: 0 0 30px;
  }
  @media (max-width: 991px) {
    h4 {
      font-size: 2rem;
    }
  }
`
const StyledResponsiveImage = styled(ResponsiveImage)`
  @media (max-width: 768px) {
    max-height: 350px;
  }
`

const KontaktShort = ({
  dark = false,
  item
}: {
  dark?: boolean
  item: {
    title: string
    text: string
    button: string
    person: {
      name: string
      image: {
        src: string
        alt: string
      }
    }
  }
}) => {
  return (
    <Section dark={dark}>
      <Container className="container">
        <div className="columns is-multiline">
          <div className="column is-4">
            <StyledResponsiveImage
              src={item.person.image.src}
              alt={item.person.image.alt}
            />
            <p>
              <strong>Ihr Ansprechpartner:</strong> {item.person.name}
            </p>
          </div>
          <ContenBox className="column is-offset-1">
            <h4>{item.title}</h4>
            <p>{item.text}</p>
            <div>
              <button
                className="button is-primary"
                onClick={async (e) => {
                  await scroller.scrollTo('contact', {
                    duration: 800,
                    delay: 500,
                    smooth: true
                  })
                  //@ts-ignore
                  if ('activeElement' in document) document.activeElement.blur()
                }}>
                {item.button}
              </button>
            </div>
          </ContenBox>
        </div>
      </Container>
    </Section>
  )
}

export default KontaktShort
